import type { LocaleObject } from '@nuxtjs/i18n'

/**
 * Get all the available locales except for the current locale.
 */
export default function () {
    const { locale, locales } = useI18n()
    return computed(() => (locales.value as LocaleObject[]).filter(i => i.code !== locale.value))
}
